import React from 'react'

const RoundTickIcon = () => {
    return (
        <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_2_3086)">
                <path d="M5.5 11C2.46726 11 0 8.53274 0 5.5C0 2.46726 2.46726 0 5.5 0C8.53274 0 11 2.46726 11 5.5C11 8.53274 8.53274 11 5.5 11ZM5.5 0.78569C2.90056 0.78569 0.78569 2.90056 0.78569 5.5C0.78569 8.09944 2.90056 10.2143 5.5 10.2143C8.09944 10.2143 10.2143 8.09944 10.2143 5.5C10.2143 2.90056 8.09944 0.78569 5.5 0.78569Z" fill="black" />
                <path d="M7.46402 7.85488C7.36348 7.85488 7.26294 7.81653 7.18624 7.73974L3.2577 3.8112C3.1042 3.65771 3.1042 3.40913 3.2577 3.25572C3.41111 3.1023 3.65978 3.10222 3.81319 3.25572L7.74172 7.18425C7.89522 7.33775 7.89522 7.58633 7.74172 7.73974C7.66502 7.81653 7.56456 7.85488 7.46402 7.85488Z" fill="black" />
                <path d="M3.5354 7.85491C3.43486 7.85491 3.33441 7.81656 3.2577 7.73977C3.1042 7.58636 3.1042 7.33769 3.2577 7.18428L7.18624 3.25575C7.33973 3.10225 7.58831 3.10225 7.74172 3.25575C7.89514 3.40916 7.89522 3.65782 7.74172 3.81124L3.81319 7.73977C3.73648 7.81656 3.63594 7.85491 3.5354 7.85491Z" fill="black" />
            </g>
            <defs>
                <clipPath id="clip0_2_3086">
                    <rect width="11" height="11" fill="white" />
                </clipPath>
            </defs>
        </svg>

    )
}

export default RoundTickIcon